// import {
//   IonPage,
//   IonHeader,
//   IonToolbar,
//   IonButtons,
//   IonMenuButton,
//   IonTitle,
//   IonContent,
//   IonIcon,
//   IonLoading,
// } from "@ionic/react";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   Container,
//   FormControl,
//   FormControlLabel,
//   IconButton,
//   List,
//   AlertTitle,
//   ListItem,
//   ListItemText,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   Modal,
//   Stack,
// } from "@mui/material";
// import Alert from "@mui/material/Alert";
// import axios from "axios";
// import React, { ChangeEvent, useEffect, useState } from "react";
// import { useParams, useLocation } from "react-router";
// import { baseUrl, config, getUserData, requestID } from "../../common/utils";
// import { Link } from "react-router-dom";
// import { ellipsisHorizontalCircle } from "ionicons/icons";
// import { useBusinessContext } from "../../BusinessContext";
// import styles from "./MemberWithdrawalList.module.css";

// export type User = {
//   accountName: string;
//   accountNumber: number;
//   activeloans: number;
//   area: string;
//   bankName: string;
//   businessAddress: string;
//   bvn: number;
//   churchAddress: string;
//   dob: string; // Date of birth as a string
//   email: string;
//   firstName: string;
//   id: number;
//   lastName: string;
//   lga: string;
//   middleName: string;
//   nextOfKin: string;
//   nextOfKinAddress: string;
//   nextOfKinPhone: string;
//   nextOfKinRelationship: string;
//   parish: string;
//   password: string; // This should not be displayed or handled in the UI
//   pastorName: string;
//   pastorPhone: string;
//   phone: string;
//   province: string;
//   residentialAddress: string;
//   savingAmount: string;
//   securityAnswer1: string;
//   securityAnswer2: string;
//   securityQuestion1: string;
//   securityQuestion2: string;
//   status: number;
//   titles: string;
//   unitHeadName: string;
//   unitHeadPhone: string;
//   user_id: string;
//   zone: string;
// };

// const MemberWithdrawalList = () => {
//   const user_id = getUserData()?.user_id;

//   const {selectedBusiness} = useBusinessContext()
//   const location = useLocation();
//   const name = location.pathname.split("/").pop()?.replace(/%20/g, " ");
//   // const { name } = useParams<{ name: string }>();
//   const url = "http://localhost/rmfwarri";
//   const [users, setUsers] = useState<any>([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [status, setStatus] = useState({ loading: false, error: false });
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [openModal, setOpenModal] = useState(false);
//   const [file, setFile] = useState<File | null>(null);
//   const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
//   const [selectedReason, setSelectedReason] = useState<string | null>(null);
//   const [actionType, setActionType] = useState<"approve" | "reject" | null>(
//     null
//   );
//   const [actionNoticeType, setActionNoticeType] = useState<"update" | "reject" | null>(
//     null
//   );
//   const [showAlert, setShowAlert] = useState<boolean>(false);
//   const [alertMsg, setAlertMsg] = useState<string>("");
//   const onShowAlert = () => {
//     setShowAlert(true);
//     setTimeout(() => setShowAlert(false), 5000);
//   };
//   const [noticePeriod, setNoticePeriod] = useState('');

//   const fetchLoanApplications = async () => {
//     try {
//       const formData = new FormData();
//       formData.append("requestID", requestID());
//       formData.append("business_id", selectedBusiness.business_id);
//       formData.append("branch_id", selectedBusiness.branch_id);

//       const response = await axios.post(
//         baseUrl() + "users/getAllMembershipRequest_caas",
//         formData,
//         config
//       );
//       console.log(response);
//       const { data } = response.data;
//       setUsers(data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//       setLoading(false);
//     }
//   };

//   const filteredUsers = users?.filter(
//     (user) =>
//       user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user?.phone?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleChangePage = (
//     event: React.MouseEvent<HTMLButtonElement> | null,
//     newPage: number
//   ) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (
//     event: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const emptyRows =
//     rowsPerPage - Math.min(rowsPerPage, users?.length - page * rowsPerPage);

//   const handleApprove = async (userId: string, selectedReason: string, file: File | null) => {
//     // alert(file);
//     setStatus({ loading: false, error: false });
//     console.log(userId);
//     try {
//       const formData = new FormData();
//       formData.append("requestID", requestID());
//       formData.append("reason", selectedReason);
//       formData.append("closureID", userId);
//       if (file) {
//         formData.append("certificate", file);
//       } else {
//         console.warn("No file selected.");
//       }

//       const response = await axios.post(
//         baseUrl() + "users/approveClosure",
//         formData,
//         config
//       );

//       if (response.data.status === true) {
//         setAlertMsg(response.data.message);
//         onShowAlert();
   
//         setSearchTerm("");
//         setOpenDialog(false);

//         setStatus({ loading: false, error: false });
//       } else {
//         setAlertMsg(response.data.message);
//         onShowAlert();
//         setOpenDialog(false);
//         setSearchTerm("");
//         setOpenDialog(false);
//         setStatus({ loading: false, error: true });
//       }

//       console.log(response);
//       fetchLoanApplications();
//     } catch (error) {
//       setStatus({ loading: false, error: true });
//       console.error("Error approving loan:", error);
//       setAlertMsg("Something went Wrong");
//     }
//   };

//   const handleReject = async (userId) => {
//     try {
//       await axios.post(`/api/reject-loan/${userId}`); // Replace with your API endpoint
//       // Refresh the list after rejecting
//       // setUsers(users.map(user =>
//       //   user.id === userId ? { ...user, status: 'Rejected' } : user
//       // ));
//     } catch (error) {
//       console.error("Error rejecting loan:", error);
//     }
//   };

//   const onUpdateNoticePeriod = async (closureID: string,noticePeriod:string) => {
//     setStatus({ loading: true, error: false });
//       try {
//         const formData = new FormData();
//         formData.append("requestID", requestID());
//         formData.append("closureID", closureID);
//         formData.append("noticePeriod", noticePeriod);
  
//         const response = await axios.post(
//           baseUrl() + "users/updateNoticePeriod",
//           formData,
//           config
//         );
//         console.log(response);
//         const data = await response.data;
//         if (data.status === true) {
//           setStatus({ loading: false, error: false });
//           setAlertMsg(response.data.message);
//           onShowAlert();
//           setNoticePeriod('')
//           fetchLoanApplications();  // pls uncomment this dont forget pls
//         } else {
//           setAlertMsg(response.data.message);
//           onShowAlert();
//           setStatus({ loading: false, error: true });
//         }
//         fetchLoanApplications(); //  pls uncomment this dont forget pls
//       } catch (error) {
//        setStatus({ loading: false, error: false });

//         console.error("Error approving loan:", error);
//       }
//     };
 

//   const handleOpenDialog = (
//     userId: string,
//     action: "approve" | "reject",
//     reason: string
//   ) => {
//     setSelectedUserId(userId);
//     setSelectedReason(reason);
//     console.log(userId, reason);
//     setActionType(action);
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedUserId(null);
//     setSelectedReason(null);
//     setActionType(null);
//   };

//   const handleConfirmAction = () => {
//     //handleCloseDialog();
//    // setOpenModal(false)
//     if (actionType && selectedUserId && selectedReason) {
//       if (actionType === "approve") {
//         handleApprove(selectedUserId, selectedReason, file);
//       } else if (actionType === "reject") {
//         handleReject(selectedUserId);
//       }
//       handleCloseDialog();
//     }
//   };

//   const handleOpenDialog2 = (userId: string, action: "update" | "reject") => {
//     setSelectedUserId(userId);
//     setActionNoticeType(action);
//     setOpenDialog(true);
//   };

//   const handleCloseDialog2 = () => {
//     setOpenDialog(false);
//     setSelectedUserId(null);
//     setActionNoticeType(null);
//   };

//   const handleConfirmAction2 = () => {
//     if (actionNoticeType && selectedUserId &&noticePeriod ) {
//       if (actionNoticeType === "update") {
//         onUpdateNoticePeriod(selectedUserId,noticePeriod);
//       } else if (actionNoticeType === "reject") {
//         // handleReject(selectedUserId);
//         handleCloseDialog();
//       }
//       handleCloseDialog();
//     }
//   };


//   const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
//     if (event.target.files && event.target.files.length > 0) {
//       setFile(event.target.files[0]);
//     } else {
//       setFile(null);
//     }
//   };
//   useEffect(() => {
//     fetchLoanApplications();
//     return () => {};
//   }, []);

//   return (
//     <IonPage>
//       <IonHeader>
//         <IonToolbar>
//           <IonButtons slot="start">
//             <IonMenuButton />
//           </IonButtons>
//           <IonTitle>{name}</IonTitle>
//         </IonToolbar>
//       </IonHeader>

//       <IonContent fullscreen>
//         {/* <Box
//           sx={{
//             paddingTop: "20px",
//             "& > :not(style)": { m: 1 },
//           }}
//         >
//           <Link to={"/folder/loanRunning/loanRunning"}>
//             <Button
//               variant="contained"
//               color="primary"
//               slot="end"
//               sx={{ m: 1, mr: 1 }}
//             >
//               View Running Loans
//             </Button>
//             <Divider orientation="horizontal" flexItem />
//           </Link>
//         </Box> */}

//         <Container component="main" sx={{ mt: 4, mb: 2 }}>
//           <Paper elevation={3} sx={{ padding: 2 }}>
//           {showAlert && (
//               <Alert severity={status.error ? "error" : "success"}>
//                 <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
//                 {alertMsg?.toUpperCase()}
//               </Alert>
//             )}
//             <TextField
//               variant="outlined"
//               margin="normal"
//               fullWidth
//               label="Search by Email or Phone"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
//                 <CircularProgress />
//               </Box>
//             ) : (
//               <>
//                 <TableContainer component={Paper} sx={{ mt: 2 }}>
//                   <Table sx={{ minWidth: 700 }}>
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>S/N</TableCell>
//                         <TableCell>Name</TableCell>
//                         <TableCell>Email</TableCell>
//                         <TableCell>Phone</TableCell>
//                         <TableCell>Reason</TableCell>
//                         <TableCell>Notice Status</TableCell>
//                         <TableCell align="right">Approval</TableCell>
//                         <TableCell align="right">Actions</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {filteredUsers
//                         ?.slice(
//                           page * rowsPerPage,
//                           page * rowsPerPage + rowsPerPage
//                         )
//                         .map((user, i) => (
//                           <TableRow key={i}>
//                             <TableCell>{page * rowsPerPage + i + 1}</TableCell>
//                             <TableCell>{user.fullName}</TableCell>
//                             <TableCell>{user.email}</TableCell>
//                             <TableCell>{user.phone}</TableCell>
//                             <TableCell>{user.reason} </TableCell>
//                             <TableCell>{user.maturityStatus}</TableCell>
//                             <TableCell align="right">
//                               {(user.status == "0" || user.status == "1") &&
//                               user.reason != "death" ? (
//                                 <Box
//                                   sx={{ display: "flex", alignItems: "center" }}
//                                 >
//                                   { user?.maturityStatus ==
//                                         user.maturityDate ? (
//                                     <Button
//                                       variant="contained"
//                                       disabled={
//                                         user?.maturityStatus !=
//                                         user.maturityDate
//                                       }
//                                       color={"success"}
//                                       onClick={() =>
//                                         handleOpenDialog(
//                                           user.closureID,
//                                           "approve",
//                                           user.reason
//                                         )
//                                       }
//                                       sx={{ mr: 1 }}
//                                     >
//                                       Push For Approval
//                                     </Button>
//                                   ) : (
//                                     <Button
//                                       variant="contained"
//                                       color="warning"
//                                       sx={{ mr: 1 }}
//                                     >
//                                       Pending
//                                     </Button>
//                                   )}
//                                 </Box>
//                               ) : (
//                                 <>
//                                   <Button
//                                     variant="contained"
//                                     color="warning"
//                                     sx={{ mr: 1 }}
//                                     onClick={() => setOpenModal(true)}
//                                   >
//                                     Upload Death Certificate
//                                   </Button>
//                                   <Modal
//                                     open={openModal}
//                                     onClose={() => setOpenModal(false)}
//                                     aria-labelledby="upload-file-modal-title"
//                                     aria-describedby="upload-file-modal-description"
//                                   >
//                                     <Box sx={style}>
//                                       <Typography
//                                         id="upload-file-modal-title"
//                                         variant="h6"
//                                         component="h2"
//                                       >
//                                         Upload File and Submit Request
//                                       </Typography>
//                                       <Typography
//                                         id="upload-file-modal-description"
//                                         sx={{ mt: 2 }}
//                                       >
//                                         Please upload your file and provide a
//                                         brief description.
//                                       </Typography>
//                                       <Stack spacing={2} sx={{ mt: 2 }}>
//                                         <TextField
//                                           type="file"
//                                           onChange={handleFileChange}
//                                           fullWidth
//                                           inputProps={{
//                                             accept: ".pdf,.doc,.docx,.jpg,.png",
//                                           }} // Specify accepted file types
//                                           sx={{ mt: 2 }}
//                                         />

//                                         <Button
//                                           variant="contained"
//                                           color="primary"
//                                           onClick={() =>
//                                             handleOpenDialog(
//                                               user.user_id,
//                                               "approve",
//                                               user.reason
//                                             )
//                                           }
//                                         >
//                                           Submit
//                                         </Button>
//                                       </Stack>
//                                     </Box>
//                                   </Modal>
//                                 </>
//                               )}
//                               {emptyRows < 0 && (
//                                 <TableRow style={{ height: 53 * emptyRows }}>
//                                   <TableCell colSpan={3} />
//                                 </TableRow>
//                               )}
//                             </TableCell>
//                             <TableCell align="right"> <IonIcon  onClick={() =>
//                                         handleOpenDialog2(user?.closureID, "update")
//                                       } size='large' icon={ellipsisHorizontalCircle}/></TableCell>
//                           </TableRow>
//                         ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//                 <TablePagination
//                   rowsPerPageOptions={[10, 25, 50]}
//                   component="div"
//                   count={filteredUsers?.length ?? 0}
//                   // count={users?.length ?? 0}
//                   rowsPerPage={rowsPerPage}
//                   page={page}
//                   onPageChange={handleChangePage}
//                   onRowsPerPageChange={handleChangeRowsPerPage}
//                 />
//               </>
//             )}
//           </Paper>
//         </Container>

//         {/* //////// */}
//         <Dialog
//           open={openDialog}
//           onClose={handleCloseDialog}
//           aria-labelledby="confirmation-dialog-title"
//           aria-describedby="confirmation-dialog-description"
//         >
//           <DialogTitle id="confirmation-dialog-title">
//             Confirm Action
//           </DialogTitle>
//           <DialogContent>
//             <Typography>
//               Are you sure you want to {actionType} this request application?
//             </Typography>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDialog} color="primary">
//               Cancel
//             </Button>
//             <Button
//               onClick={handleConfirmAction}
//               color={actionType === "approve" ? "success" : "error"}
//               autoFocus
//             >
//               {actionType === "approve" ? "Approve" : "Reject"}
//             </Button>
//           </DialogActions>
//         </Dialog>
//         {/*  */}

//         <Dialog
//           open={openDialog}
//           onClose={handleCloseDialog2}
//           aria-labelledby="confirmation-dialog-title"
//           aria-describedby="confirmation-dialog-description"
//         >
//           <DialogTitle id="confirmation-dialog-title">
//             Confirm Action
//           </DialogTitle>
//           <DialogContent>
//             <Typography>
//               Are you sure you want to {actionNoticeType} this Cash Withdrawal Notice Period?
//             </Typography>

//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 width: "90%",

//                 marginTop: "1%",
//                 // marginLeft:'40%',
//                 "& > :not(style)": { m: 4 },
//               }}
//             >
//               <FormControl fullWidth>
//                 {/* <InputLabel id="demo-simple-select-label"> </InputLabel> */}
//                 <TextField
//                   required
//                   fullWidth
//                   type="number"
//                   helperText={parseInt(noticePeriod) > 120 && "number cannot be greater than 120"}
//                   label="Enter Notice Period"
//                   margin="normal"
//                   error={parseInt(noticePeriod) > 120}
                  
//                   value={noticePeriod}
//                   onChange={(e) => setNoticePeriod(e.target.value)}
              
//                 />
//               </FormControl>
//             </Box>
//           </DialogContent>
//           <DialogActions>
//           <Button
//               onClick={handleConfirmAction2}
//               color={actionNoticeType === "update" ? "success" : "error"}
//               autoFocus
//             >
//               {actionNoticeType === "update" ? "Update" : "Reject"}
//             </Button>
//             <Button onClick={handleCloseDialog2} color="primary">
//               Cancel
//             </Button>
          
//           </DialogActions>
//         </Dialog>
//       </IonContent>
//       <IonLoading isOpen={status.loading} message={'Please wait'}/>
//     </IonPage>
//   );
// };

// export default MemberWithdrawalList;
// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   maxWidth: 800,
//   bgcolor: "background.paper",
//   color: "black",
//   border: "2px solid #000",
//   boxShadow: 24,
//   borderRadius: 2,
//   p: 4,
// };




import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
  IonLoading,
} from "@ionic/react"
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  AlertTitle,
  Paper,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Stack,
  Chip,
  Fade,
  Slide,
} from "@mui/material"
import Alert from "@mui/material/Alert"
import {
  Search as SearchIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  CheckCircle as CheckCircleIcon,
  Pending as PendingIcon,
  Upload as UploadIcon,
  MoreHoriz as MoreHorizIcon,
  Assignment as AssignmentIcon,
} from "@mui/icons-material"
import axios from "axios"
import React from "react"
import { type ChangeEvent, useEffect, useState } from "react"
import { useLocation } from "react-router"
import { baseUrl, config, getUserData, requestID } from "../../common/utils"
 import { TransitionProps } from "@mui/material/transitions";
import styles from "./MemberWithdrawalList.module.css"
import { useBusinessContext } from "../../context/business-context"

export type User = {
  accountName: string
  accountNumber: number
  activeloans: number
  area: string
  bankName: string
  businessAddress: string
  bvn: number
  churchAddress: string
  dob: string // Date of birth as a string
  email: string
  firstName: string
  id: number
  lastName: string
  lga: string
  middleName: string
  nextOfKin: string
  nextOfKinAddress: string
  nextOfKinPhone: string
  nextOfKinRelationship: string
  parish: string
  password: string // This should not be displayed or handled in the UI
  pastorName: string
  pastorPhone: string
  phone: string
  province: string
  residentialAddress: string
  savingAmount: string
  securityAnswer1: string
  securityAnswer2: string
  securityQuestion1: string
  securityQuestion2: string
  status: number
  titles: string
  unitHeadName: string
  unitHeadPhone: string
  user_id: string
  zone: string
}



const MemberWithdrawalList = () => {
  const user_id = getUserData()?.user_id

  const { selectedBusiness } = useBusinessContext()
  const location = useLocation()
  const name = location.pathname.split("/").pop()?.replace(/%20/g, " ") || "Member Withdrawal List"
  const [users, setUsers] = useState<any>([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")
  const [status, setStatus] = useState({ loading: false, error: false })
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [openDialog, setOpenDialog] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [file, setFile] = useState<File | null>(null)
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null)
  const [selectedReason, setSelectedReason] = useState<string | null>(null)
  const [actionType, setActionType] = useState<"approve" | "reject" | null>(null)
  const [actionNoticeType, setActionNoticeType] = useState<"update" | "reject" | null>(null)
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>("")
  const onShowAlert = () => {
    setShowAlert(true)
    setTimeout(() => setShowAlert(false), 5000)
  }
  const [noticePeriod, setNoticePeriod] = useState("")


  const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

  const fetchLoanApplications = async () => {
    try {
      const formData = new FormData()
      formData.append("requestID", requestID())
      formData.append("business_id", selectedBusiness.business_id)
      formData.append("branch_id", selectedBusiness.branch_id)

      const response = await axios.post(baseUrl() + "users/getAllMembershipRequest_caas", formData, config)
      console.log(response)
      const { data } = response.data
      setUsers(data)
      setLoading(false)
    } catch (error) {
      console.error("Error fetching users:", error)
      setLoading(false)
    }
  }

  const filteredUsers = users?.filter(
    (user) =>
      user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.phone?.toLowerCase().includes(searchTerm.toLowerCase()),
  )

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(Number.parseInt(event.target.value, 10))
    setPage(0)
  }
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, users?.length - page * rowsPerPage)

  const handleApprove = async (userId: string, selectedReason: string, file: File | null) => {
    setStatus({ loading: false, error: false })
    console.log(userId)
    try {
      const formData = new FormData()
      formData.append("requestID", requestID())
      formData.append("reason", selectedReason)
      formData.append("closureID", userId)
      if (file) {
        formData.append("certificate", file)
      } else {
        console.warn("No file selected.")
      }

      const response = await axios.post(baseUrl() + "users/approveClosure", formData, config)

      if (response.data.status === true) {
        setAlertMsg(response.data.message)
        onShowAlert()
        setSearchTerm("")
        setOpenDialog(false)
        setStatus({ loading: false, error: false })
      } else {
        setAlertMsg(response.data.message)
        onShowAlert()
        setOpenDialog(false)
        setSearchTerm("")
        setOpenDialog(false)
        setStatus({ loading: false, error: true })
      }

      console.log(response)
      fetchLoanApplications()
    } catch (error) {
      setStatus({ loading: false, error: true })
      console.error("Error approving loan:", error)
      setAlertMsg("Something went Wrong")
    }
  }

  const handleReject = async (userId) => {
    try {
      await axios.post(`/api/reject-loan/${userId}`) // Replace with your API endpoint
    } catch (error) {
      console.error("Error rejecting loan:", error)
    }
  }

  const onUpdateNoticePeriod = async (closureID: string, noticePeriod: string) => {
    setStatus({ loading: true, error: false })
    try {
      const formData = new FormData()
      formData.append("requestID", requestID())
      formData.append("closureID", closureID)
      formData.append("noticePeriod", noticePeriod)

      const response = await axios.post(baseUrl() + "users/updateNoticePeriod", formData, config)
      console.log(response)
      const data = await response.data
      if (data.status === true) {
        setStatus({ loading: false, error: false })
        setAlertMsg(response.data.message)
        onShowAlert()
        setNoticePeriod("")
        fetchLoanApplications()
      } else {
        setAlertMsg(response.data.message)
        onShowAlert()
        setStatus({ loading: false, error: true })
      }
      fetchLoanApplications()
    } catch (error) {
      setStatus({ loading: false, error: false })
      console.error("Error approving loan:", error)
    }
  }

  const handleOpenDialog = (userId: string, action: "approve" | "reject", reason: string) => {
    setSelectedUserId(userId)
    setSelectedReason(reason)
    console.log(userId, reason)
    setActionType(action)
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setSelectedUserId(null)
    setSelectedReason(null)
    setActionType(null)
  }

  const handleConfirmAction = () => {
    if (actionType && selectedUserId && selectedReason) {
      if (actionType === "approve") {
        handleApprove(selectedUserId, selectedReason, file)
      } else if (actionType === "reject") {
        handleReject(selectedUserId)
      }
      handleCloseDialog()
    }
  }

  const handleOpenDialog2 = (userId: string, action: "update" | "reject") => {
    setSelectedUserId(userId)
    setActionNoticeType(action)
    setOpenDialog(true)
  }

  const handleCloseDialog2 = () => {
    setOpenDialog(false)
    setSelectedUserId(null)
    setActionNoticeType(null)
  }

  const handleConfirmAction2 = () => {
    if (actionNoticeType && selectedUserId && noticePeriod) {
      if (actionNoticeType === "update") {
        onUpdateNoticePeriod(selectedUserId, noticePeriod)
      } else if (actionNoticeType === "reject") {
        handleCloseDialog()
      }
      handleCloseDialog()
    }
  }

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0])
    } else {
      setFile(null)
    }
  }

  useEffect(() => {
    fetchLoanApplications()
    return () => {}
  }, [])

  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar className={styles.headerToolbar}>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle className={styles.headerTitle}>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <div className={styles.container}>
          <Container component="main" sx={{ mt: 2, mb: 2 }}>
            <Paper elevation={0} className={styles.mainPaper} sx={{ padding: 3 }}>
              {showAlert && (
                <Fade in={showAlert}>
                  <Alert
                    severity={status.error ? "error" : "success"}
                    className={styles.alertContainer}
                    sx={{
                      borderRadius: "15px",
                      backdropFilter: "blur(10px)",
                      background: status.error ? "rgba(244, 67, 54, 0.1)" : "rgba(76, 175, 80, 0.1)",
                    }}
                  >
                    <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
                    {alertMsg?.toUpperCase()}
                  </Alert>
                </Fade>
              )}

              <Box sx={{ position: "relative", mb: 3 }}>
                {/* <SearchIcon
                  sx={{
                    position: "absolute",
                    left: 15,
                    top: "35%",
                    transform: "translateY(-50%)",
                    color: "#06b6d4",
                    zIndex: 1,
                  }}
                /> */}
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Search by Email or Phone"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className={styles.searchField}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      paddingLeft: "50px",
                    },
                  }}
                />
              </Box>

              {loading ? (
                <Box className={styles.loadingContainer}>
                  <CircularProgress size={60} className={styles.loadingSpinner} />
                  <Typography variant="h6" className={styles.loadingText}>
                    Loading member withdrawal requests...
                  </Typography>
                </Box>
              ) : (
                <>
                  <TableContainer component={Paper} className={styles.tableContainer}>
                    <Table sx={{ minWidth: 700 }}>
                      <TableHead className={styles.tableHead}>
                        <TableRow>
                          <TableCell className={styles.tableHeadCell}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <AssignmentIcon fontSize="small" />
                              S/N
                            </Box>
                          </TableCell>
                          <TableCell className={styles.tableHeadCell}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <PersonIcon fontSize="small" />
                              Name
                            </Box>
                          </TableCell>
                          <TableCell className={styles.tableHeadCell}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <EmailIcon fontSize="small" />
                              Email
                            </Box>
                          </TableCell>
                          <TableCell className={styles.tableHeadCell}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <PhoneIcon fontSize="small" />
                              Phone
                            </Box>
                          </TableCell>
                          <TableCell className={styles.tableHeadCell}>Reason</TableCell>
                          <TableCell className={styles.tableHeadCell}>Notice Status</TableCell>
                          <TableCell align="right" className={styles.tableHeadCell}>
                            Approval
                          </TableCell>
                          <TableCell align="right" className={styles.tableHeadCell}>
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user, i) => (
                          <TableRow key={i} className={styles.tableRow}>
                            <TableCell className={styles.tableCell}>
                              <Chip
                                label={page * rowsPerPage + i + 1}
                                size="small"
                                sx={{
                                  background: "linear-gradient(45deg, #061b5b 0%, #06b6d4 100%)",
                                  color: "white",
                                  fontWeight: 600,
                                }}
                              />
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <Typography variant="body2" fontWeight={600}>
                                {user.fullName}
                              </Typography>
                            </TableCell>
                            <TableCell className={styles.tableCell}>{user.email}</TableCell>
                            <TableCell className={styles.tableCell}>{user.phone}</TableCell>
                            <TableCell className={styles.tableCell}>
                              <Chip
                                label={user.reason}
                                size="small"
                                className={styles.statusChip}
                                sx={{
                                  background:
                                    user.reason === "death"
                                      ? "linear-gradient(45deg, #f44336 0%, #ef5350 100%)"
                                      : "linear-gradient(45deg, #2196f3 0%, #64b5f6 100%)",
                                  color: "white",
                                }}
                              />
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <Chip
                                label={user.maturityStatus}
                                size="small"
                                className={styles.statusChip}
                                sx={{
                                  background:
                                    user.maturityStatus === user.maturityDate
                                      ? "linear-gradient(45deg, #4caf50 0%, #66bb6a 100%)"
                                      : "linear-gradient(45deg, #ff9800 0%, #ffb74d 100%)",
                                  color: "white",
                                }}
                              />
                            </TableCell>
                            <TableCell align="right" className={styles.tableCell}>
                              {(user.status == "0" || user.status == "1") && user.reason != "death" ? (
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                  {user?.maturityStatus == user.maturityDate ? (
                                    <Button
                                      variant="contained"
                                      disabled={user?.maturityStatus != user.maturityDate}
                                      className={styles.approveButton}
                                      startIcon={<CheckCircleIcon />}
                                      onClick={() => handleOpenDialog(user.closureID, "approve", user.reason)}
                                    >
                                      Push For Approval
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="contained"
                                      className={styles.pendingButton}
                                      startIcon={<PendingIcon />}
                                    >
                                      Pending
                                    </Button>
                                  )}
                                </Box>
                              ) : (
                                <>
                                  <Button
                                    variant="contained"
                                    className={styles.uploadButton}
                                    startIcon={<UploadIcon />}
                                    onClick={() => setOpenModal(true)}
                                  >
                                    Upload Death Certificate
                                  </Button>
                                  <Modal
                                    open={openModal}
                                    onClose={() => setOpenModal(false)}
                                    aria-labelledby="upload-file-modal-title"
                                    aria-describedby="upload-file-modal-description"
                                    className={styles.modal}
                                  >
                                    <Fade in={openModal}>
                                      <Box
                                        sx={{
                                          position: "absolute",
                                          top: "50%",
                                          left: "50%",
                                          transform: "translate(-50%, -50%)",
                                          maxWidth: 800,
                                          bgcolor: "background.paper",
                                          color: "black",
                                          border: "2px solid #000",
                                          boxShadow: 24,
                                          borderRadius: 2,
                                          p: 4,
                                          background: "rgba(255, 255, 255, 0.95)",
                                          backdropFilter: "blur(20px)",
                                          // borderRadius: "20px",
                                          // border: "1px solid rgba(255, 255, 255, 0.2)",
                                          // boxShadow: "0 20px 40px rgba(6, 27, 91, 0.2)",
                                        }}
                                        className={styles.modalBox}
                                      >
                                        <Typography
                                          id="upload-file-modal-title"
                                          variant="h6"
                                          component="h2"
                                          sx={{
                                            background: "linear-gradient(45deg, #061b5b 0%, #06b6d4 100%)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent",
                                            fontWeight: 700,
                                            mb: 2,
                                          }}
                                        >
                                          Upload File and Submit Request
                                        </Typography>
                                        <Typography
                                          id="upload-file-modal-description"
                                          sx={{ mt: 2, color: "#666", mb: 3 }}
                                        >
                                          Please upload your file and provide a brief description.
                                        </Typography>
                                        <Stack spacing={3}>
                                          <TextField
                                            type="file"
                                            onChange={handleFileChange}
                                            fullWidth
                                            className={styles.fileInput}
                                            inputProps={{
                                              accept: ".pdf,.doc,.docx,.jpg,.png",
                                            }}
                                          />
                                          <Button
                                            variant="contained"
                                            className={styles.dialogButtonPrimary}
                                            startIcon={<UploadIcon />}
                                            onClick={() => handleOpenDialog(user.user_id, "approve", user.reason)}
                                          >
                                            Submit
                                          </Button>
                                        </Stack>
                                      </Box>
                                    </Fade>
                                  </Modal>
                                </>
                              )}
                            </TableCell>
                            <TableCell align="right" className={styles.tableCell}>
                              <Box
                                className={styles.actionIcon}
                                onClick={() => handleOpenDialog2(user?.closureID, "update")}
                              >
                                <MoreHorizIcon fontSize="large" />
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Box className={styles.pagination}>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50]}
                      component="div"
                      count={filteredUsers?.length ?? 0}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      sx={{
                        "& .MuiTablePagination-toolbar": {
                          color: "#061b5b",
                          fontWeight: 500,
                        },
                        "& .MuiTablePagination-selectIcon": {
                          color: "#06b6d4",
                        },
                      }}
                    />
                  </Box>
                </>
              )}
            </Paper>
          </Container>
        </div>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="confirmation-dialog-title"
          aria-describedby="confirmation-dialog-description"
          className={styles.dialog}
          PaperProps={{
            className: styles.dialogPaper,
          }}
          // TransitionComponent={Slide}
          // TransitionProps={{ direction: "up" }}
          TransitionComponent={Transition}
        >
          <DialogTitle id="confirmation-dialog-title" className={styles.dialogTitle}>
            Confirm Action
          </DialogTitle>
          <DialogContent className={styles.dialogContent}>
            <Typography sx={{ color: "#666", fontSize: "1.1rem" }}>
              Are you sure you want to {actionType} this request application?
            </Typography>
          </DialogContent>
          <DialogActions className={styles.dialogActions}>
            <Button
              onClick={handleCloseDialog}
              className={styles.dialogButton}
              sx={{
                color: "#666",
                border: "1px solid #ddd",
                "&:hover": {
                  background: "#f5f5f5",
                  transform: "translateY(-1px)",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmAction}
              className={`${styles.dialogButton} ${styles.dialogButtonPrimary}`}
              autoFocus
            >
              {actionType === "approve" ? "Approve" : "Reject"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog2}
          aria-labelledby="confirmation-dialog-title"
          aria-describedby="confirmation-dialog-description"
          className={styles.dialog}
          PaperProps={{
            className: styles.dialogPaper,
          }}
          // TransitionComponent={Slide}
          // TransitionProps={{ direction: "up" }}
          TransitionComponent={Transition}
        >
          <DialogTitle id="confirmation-dialog-title" className={styles.dialogTitle}>
            Update Notice Period
          </DialogTitle>
          <DialogContent className={styles.dialogContent}>
            <Typography sx={{ color: "#666", fontSize: "1.1rem", mb: 3 }}>
              Are you sure you want to {actionNoticeType} this Cash Withdrawal Notice Period?
            </Typography>

            <FormControl fullWidth>
              <TextField
                required
                fullWidth
                type="number"
                helperText={Number.parseInt(noticePeriod) > 120 && "Number cannot be greater than 120"}
                label="Enter Notice Period (Days)"
                margin="normal"
                error={Number.parseInt(noticePeriod) > 120}
                value={noticePeriod}
                onChange={(e) => setNoticePeriod(e.target.value)}
                className={styles.fileInput}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "15px",
                  },
                }}
              />
            </FormControl>
          </DialogContent>
          <DialogActions className={styles.dialogActions}>
            <Button
              onClick={handleConfirmAction2}
              className={`${styles.dialogButton} ${styles.dialogButtonPrimary}`}
              autoFocus
            >
              {actionNoticeType === "update" ? "Update" : "Reject"}
            </Button>
            <Button
              onClick={handleCloseDialog2}
              className={styles.dialogButton}
              sx={{
                color: "#666",
                border: "1px solid #ddd",
                "&:hover": {
                  background: "#f5f5f5",
                  transform: "translateY(-1px)",
                },
              }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </IonContent>

      <IonLoading isOpen={status.loading} message={"Please wait..."} spinner="crescent" cssClass="custom-loading" />
    </IonPage>
  )
}

export default MemberWithdrawalList
